<template>
    <a
        class="map-blog-post"
        :class="{
            'map-no-image': noImage,
            'map-featured': featured,
        }"
        @click.prevent="read_more"
    >
        <div class="map-article-info">
            <div class="map-article-info-inner" v-if="!featured">
                <span class="map-article-center">Countering Opposition</span>
                <h2>{{ title }}</h2>
                <span class="map-article-date" v-if="!featured">{{ get_post_date() }}</span>
            </div>
            <template v-if="!noImage">
                <lazy-img :src="get_image()" v-if="showImage" />
                <div v-else class="map-article-image-placeholder"></div>
            </template>
            <h2 v-if="featured">{{ title }}</h2>
            <!-- <p>{{ excerpt }}</p> -->
        </div>
        <div class="map-article-author">
            <profile-picture :src="get_author_picture()"></profile-picture>
            <p>by {{ author.name || '' }} {{ author.surname || '' }}</p>
        </div>
    </a>
</template>

<script>
    import LazyImg from '@/components/LazyImg';
    import ProfilePicture from '@/components/ProfilePicture';
    import { Utils } from  '@/helpers';

    import dayjs from 'dayjs';
    import customParseFormat from 'dayjs/plugin/customParseFormat';

    export default
    {
        name: 'blog-post',
        components:
        {
            LazyImg,
            ProfilePicture,
        },
        props:
        {
            featured: Boolean,
            noImage: Boolean,
            image: [String, Object],
            author: Object,
            title: String,
            date: String,
            excerpt: String,
            link: String,
        },
        data()
        {
            return {
                showImage: true,
            };
        },
        watch: {
            image()
            {
                this.showImage = null;
                setTimeout(() => this.showImage = this.image);
            },
        },
        mounted()
        {
            this.showImage = !!this.image;
        },
        methods:
        {
            read_more()
            {
                this.$router.push(this.link);
            },
            get_image()
            {
                if (this.image && this.image.id)
                {
                    return process.env.VUE_APP_BACKEND_URL + 'api/files/' + this.image.id + '/370x370_crop';
                }
                else if (this.image)
                {
                    return this.image;
                }

                this.showImage = false;
            },
            get_author_picture()
            {
                if (this.author && this.author.image)
                {
                    return process.env.VUE_APP_BACKEND_URL + 'api/files/' + this.author.image.id;
                }
            },
            get_post_date()
            {
                dayjs.extend(customParseFormat);

                return Utils.timeDiff(new Date(), dayjs(this.date, 'DD/MM/YYYY hh:mm A').toDate());
            },
        },
    }
</script>
